const ANCHO_CONTENEDOR_OPCIONES = 220;

const useOpciones = (tipo = "turnos") => {
    const ocultarCuadroOpciones = () => {
        document.getElementById(`opciones-${tipo}`).style.display = "none";
    };

    const resetOpciones = () => {
        const opciones = document.querySelectorAll(
            `.lista-opciones-${tipo} .opcion`
        );
        opciones.forEach((opcion) => (opcion.style.display = ""));
    };

    const resetScrollOpciones = () => {
        const divOpciones = document.querySelector(
            `#opciones-${tipo} .opciones`
        );
        divOpciones.scrollTo({ top: 0 });
    };

    const mostrarCuadroOpciones = (evento, turnosSeleccionados = []) => {
        const posicionMouseX = mouseX(evento);
        const posicionMouseY = mouseY(evento);

        const altoPantalla = Math.max(
            document.body.offsetHeight,
            document.documentElement.clientHeight,
            document.documentElement.offsetHeight
        );

        const opciones = document.getElementById(`opciones-${tipo}`);
        const altoContenedor = altoPantalla * 0.3;
        opciones.style.top =
            posicionMouseY -
            (posicionMouseY + altoContenedor >= altoPantalla
                ? altoContenedor + 70
                : 38) +
            "px";

        opciones.style.left =
            posicionMouseX -
            (posicionMouseX - ANCHO_CONTENEDOR_OPCIONES <= 100 ? 80 : 230) +
            "px";

        opciones.style.display = "block";
        opciones.className = "activo";

        focusBuscadorOpciones();

        if (tipo == "actividades") {
            seleccionarActividades(turnosSeleccionados);
        }
    };

    /**
     * seleccionarActividades
     *
     * @var [type]
     */
    const seleccionarActividades = (turnosSeleccionados = []) => {
        const idsIconos = [];

        turnosSeleccionados.forEach((turno) => {
            const iconos =
                document.querySelectorAll(
                    `#${turno.idceldaturno} .iconos-actividades .actividad`
                ) ?? [];

            iconos.forEach((icono) => idsIconos.push(icono.dataset.id));
        });

        const opciones =
            document.querySelectorAll(`#opciones-${tipo} .opcion`) ?? [];

        opciones.forEach((opcion) => {
            opcion.style.display = "flex";

            const boton = opcion.querySelector("button");
            boton.style.display = idsIconos.includes(boton.dataset.actividad)
                ? ""
                : "none";
        });
    };

    const focusBuscadorOpciones = () => {
        const buscador = document.querySelector(
            `#opciones-${tipo} .buscador-container #buscador`
        );
        buscador.value = "";
        buscador.focus();
    };

    function mouseX(evt) {
        if (evt.pageX) {
            return evt.pageX;
        } else if (evt.clientX) {
            return (
                evt.clientX +
                (document.documentElement.scrollLeft
                    ? document.documentElement.scrollLeft
                    : document.body.scrollLeft)
            );
        } else {
            return null;
        }
    }

    function mouseY(evt) {
        if (evt.pageY) {
            return evt.pageY;
        } else if (evt.clientY) {
            return (
                evt.clientY +
                (document.documentElement.scrollTop
                    ? document.documentElement.scrollTop
                    : document.body.scrollTop)
            );
        } else {
            return null;
        }
    }

    return {
        ocultarCuadroOpciones,
        resetOpciones,
        resetScrollOpciones,
        mostrarCuadroOpciones,
        focusBuscadorOpciones,
    };
};

export default useOpciones;
